import React, {ComponentProps, FC, ReactElement, useState} from 'react';

import {useFieldContext} from '@/components/AppForm/context';
import {FloatingWrapper} from '@/components/AppForm/primitives/FloatingWrapper';
import Input from '@/components/InputNBW/InputNBW';
import {twx} from '@/utils/tailwindUtils';

interface IPasswordInputProps extends Omit<ComponentProps<'input'>, 'type'> {
    containerClassName?: string;
    warningIcon?: ReactElement;
    hidePasswordButton?: ReactElement;
    showPasswordButton?: ReactElement;
}

export const FieldPasswordInput: FC<IPasswordInputProps> = ({
    containerClassName,
    value,
    warningIcon,
    hidePasswordButton,
    showPasswordButton,
    ...rest
}) => {
    const {id, warningMessage, name} = useFieldContext();
    const [isVisible, setIsVisible] = useState(false);
    const isValid = !warningMessage;

    const isShowSupported = Boolean(hidePasswordButton && showPasswordButton);

    return (
        <div className={twx('relative w-full', containerClassName)}>
            <Input
                name={name}
                aria-invalid={isValid}
                /*@ts-ignore*/
                value={value}
                minLength={3}
                maxLength={50}
                id={id}
                type={isVisible ? 'text' : 'password'}
                {...rest}
            />
            <FloatingWrapper>
                {isShowSupported && (
                    <div onClick={() => setIsVisible((prev) => !prev)}>
                        {isVisible ? hidePasswordButton : showPasswordButton}
                    </div>
                )}
                {!isValid && !isShowSupported && warningIcon}
            </FloatingWrapper>
        </div>
    );
};
